// Stepper of the court booking wizard (desktop). Shared by the normal reservation checkout and the
// open-match create flow so both show the same markup (`.steps` styles live in reservas.css).
// `current` is 1-based; earlier steps render as done. `allDone` marks every step done (final screen).
import React from "react";
import RIcon from "../../reservas/components/ReservasIcons";

const BookingStepper = ({ steps, current, allDone = false, compact = false }) => {
	const isDone = (n) => allDone || n < current;
	return (
		<div className={`steps${compact ? " steps-compact" : ""}`}>
			{steps.map((label, i) => {
				const n = i + 1;
				const done = isDone(n);
				const on = !done && n === current;
				return (
					<React.Fragment key={label}>
						<div className={`step${done ? " done" : on ? " on" : ""}`}>
							<span className="dot">{done ? <RIcon name="check" width={13} height={13} /> : n}</span>
							{label}
						</div>
						{n < steps.length && <div className={`step-sep${done ? " done" : ""}`} />}
					</React.Fragment>
				);
			})}
		</div>
	);
};

export default BookingStepper;
